import React from 'react';

// Types
import { FilterItem } from '@src/types/search';

const Swatches = ({
  filter,
  appliedFilters,
  onFilterUpdate
}: {
  filter: FilterItem;
  appliedFilters: any;
  onFilterUpdate: (input: string, applying: boolean, filterId: string, value: string) => void;
}) => {
  const { values, label } = filter;

  return (
    <div>
      <p className='b6--bold mb-4'>{label}</p>

      <div className='flex flex-wrap gap-4'>
        {values.map((value) => {
          const { swatch, input, id } = value;
          const color = swatch?.color;
          const image = swatch?.image?.previewImage;

          // Handle different appliedFilters formats - could be array or object
          let isApplied = false;
          if (Array.isArray(appliedFilters)) {
            // Legacy format: appliedFilters is an array of strings
            isApplied = appliedFilters.some((applied: string) => applied === input);
          } else if (appliedFilters && typeof appliedFilters === 'object') {
            // New format: appliedFilters is an object like {filterKey: [values]}
            // Check if any filter key contains this input value
            isApplied = Object.values(appliedFilters).some((filterValues: any) => {
              if (Array.isArray(filterValues)) {
                return filterValues.some((val) => {
                  // Handle both direct value match and JSON input parsing
                  if (val === input) return true;

                  // Try to parse input as JSON to extract the actual filter value
                  try {
                    const parsedInput = JSON.parse(input);
                    if (parsedInput.taxonomyMetafield && parsedInput.taxonomyMetafield.value === val) {
                      return true;
                    }
                    if (parsedInput.productMetafield && parsedInput.productMetafield.value === val) {
                      return true;
                    }
                    // Add other filter type checks as needed
                  } catch (e) {
                    // Not JSON, continue with direct comparison
                  }

                  return false;
                });
              }
              return false;
            });
          }
          // If appliedFilters is null/undefined, isApplied remains false

          return (
            <label
              key={id}
              className={`w-3 h-3 md:w-5 md:h-5 rounded-sm cursor-pointer has-[input:checked]:border-2  border-white has-[input:checked]:shadow-[0_0_0_1px_#000000] ${
                color?.toLowerCase() === '#ffffff' ? 'shadow' : ''
              }`}
              style={color ? { backgroundColor: color } : image ? { backgroundImage: `url(${image.url})` } : {}}
              title={value.label}
              htmlFor={id}
            >
              <input
                type='checkbox'
                id={id}
                onChange={() => onFilterUpdate(input, !isApplied, id, value.label)}
                className='hidden'
                checked={isApplied}
              />
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default Swatches;
